"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyInputPropTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _propTypes = require("../propTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var currencyInputPropTypes = _objectSpread(_objectSpread({}, _propTypes.inputBasePropTypes), {}, {
  code: _stencilReactDesc.PropTypes.string.description('The currency code, e.g. "USD", "GBP".'),
  locale: _stencilReactDesc.PropTypes.string.description('Locale that will be used to format the currency. Should be an Intl-compatible string, such as "en-US".'),
  onChange: _stencilReactDesc.PropTypes.func.description('Callback function that will be called when the input is changed. It passes both the currency formatted string, and the number.').format('(e: React.ChangeEvent<HTMLInputElement>, formattedValue: string, unformattedValue: number) => void')
});

exports.currencyInputPropTypes = currencyInputPropTypes;